export default __webpack_public_path__ + "static/media/landing_page_brain.7ddcfc84.png";